import { useEffect, useState } from "react";
import { api, fmtDate } from "@/lib/api";
import PageHeader, { EmptyState } from "@/components/PageHeader";
import { toast } from "sonner";
import { ShieldCheck } from "@phosphor-icons/react";

export default function AuditLogs() {
  const [rows, setRows] = useState([]);
  const [module, setModule] = useState("");

  const load = async () => {
    try {
      const params = new URLSearchParams(); if (module) params.set("module", module);
      const { data } = await api.get(`/audit/logs?${params}`);
      setRows(data);
    } catch { toast.error("Load failed"); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [module]);

  const modules = Array.from(new Set(rows.map(r=>r.module))).sort();

  return (
    <div data-testid="audit-page" className="page-fade">
      <PageHeader eyebrow="Compliance" title="Audit log" description="A non-editable trail of every mutation, login, dispatch, signature, export and webhook." />
      <div className="flex gap-3 mb-6">
        <select value={module} onChange={(e)=>setModule(e.target.value)} className="input-soft max-w-[240px]" data-testid="audit-module-filter">
          <option value="">All modules</option>
          {modules.map(m=><option key={m} value={m}>{m}</option>)}
        </select>
      </div>
      <div className="card-soft p-0 overflow-x-auto">
        <table className="table-modern">
          <thead><tr><th>When</th><th>User</th><th>Role</th><th>Action</th><th>Module</th><th>Record</th><th>Details</th></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r._id} data-testid={`audit-row-${r._id}`}>
                <td className="text-xs text-muted-foreground whitespace-nowrap">{fmtDate(r.created_at)}</td>
                <td className="text-sm">{r.user_email || "system"}</td>
                <td className="text-xs text-muted-foreground capitalize">{r.role || "—"}</td>
                <td><span className="status-chip chip-taupe">{r.action}</span></td>
                <td className="text-sm capitalize">{r.module}</td>
                <td className="font-mono text-xs">{r.record_id ? r.record_id.slice(-10) : "—"}</td>
                <td className="text-xs text-muted-foreground max-w-md">
                  {r.reason && <div>{r.reason}</div>}
                  {r.changes && <pre className="whitespace-pre-wrap font-mono text-[11px]">{JSON.stringify(r.changes).slice(0,140)}</pre>}
                </td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={7}><EmptyState icon={ShieldCheck} title="No audit entries" description="Actions performed by your team will be logged here." /></td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
